function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  className: "color_fill",
  id: "Icon/List/connection-offline",
  transform: "translate(-2.000000, -5.000000)",
  fill: "#D9D6D4",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "wifi-24px",
  transform: "translate(2.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,2.63446391 L1.18181818,3.79183411 C4.11863636,0.915769169 8.88136364,0.915769169 11.8181818,3.79183411 L13,2.63446391 C9.41318182,-0.878154638 3.59272727,-0.878154638 0,2.63446391 Z M4.72727273,7.2639447 L6.5,9 L8.27272727,7.2639447 C7.29772727,6.30332744 5.70818182,6.30332744 4.72727273,7.2639447 Z M2.36363636,4.94920431 L3.54545455,6.10657451 C5.17636364,4.50940363 7.82363636,4.50940363 9.45454545,6.10657451 L10.6363636,4.94920431 C8.35545455,2.71547983 4.65045455,2.71547983 2.36363636,4.94920431 Z",
  id: "Shape"
}))));

function SvgWifiOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "9px",
    viewBox: "0 0 13 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOff);
export default __webpack_public_path__ + "static/media/wifi_off.4bd1ac37.svg";
export { ForwardRef as ReactComponent };